$(function () {
  const $folderSearchInput = $(".ftp-folder-search")
  const $fileSearchInput = $(".ftp-file-search")

  const userId = $folderSearchInput.data('user-id')

  $folderSearchInput.select2({
    ajax: {
      url: userId ? `/curators/ftp_folder_search/${userId}` : `/curators/ftp_folder_search`,
      data: function (params) {
        return {
          search_type: 'folders',
          query: params.term
        }
      },
      dataType: 'json',
      delay: 500,
      processResults: function (data, params) {
        return {
          results: data.entries.map(el => {
            return {
              text: el,
              id: el
            }
          })
        }
      },
      cache: true
    }
  })

  $fileSearchInput.select2({
    ajax: {
      url: `/curators/ftp_folder_search/${userId}`,
      data: function (params) {
        return {
          search_type: 'files',
          folder: $folderSearchInput.val(),
          query: params.term
        }
      },
      dataType: 'json',
      delay: 500,
      processResults: function (data, params) {
        return {
          results: data.entries.map(el => {
            return {
              text: el,
              id: el
            }
          })
        }
      },
      cache: true
    }
  })
});

$(document).on("turbolinks:before-cache", function() {
  $(".ftp-folder-search").select2('destroy');
  $(".ftp-file-search").select2('destroy');
})